import { ListJobTasksResponseSchema, type ListJobTasksResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

type UseJobTasksOptions = CustomUseQueryOptions<ListJobTasksResponse> & {
  jobId: string;
};

export function useJobTasks({ jobId, ...options }: UseJobTasksOptions) {
  return useQuery(
    queryKeys.jobTasks(jobId),
    async () => {
      const api = getPrivateApi();
      const listJobTasksResponse = await api.listJobTasks({ jobId });

      return ListJobTasksResponseSchema.parse(listJobTasksResponse);
    },
    options,
  );
}
